import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';

export const FiClusterStateResolvePageTitle = [PageTitleService, 'cluster', FiClusterStateResolvePageTitle_resoleFunc];

export function FiClusterStateResolvePageTitle_resoleFunc(pageTitleService: PageTitleService, cluster) {
    pageTitleService.setTitleByItem(cluster);
}
